/* global BUILD_TYPE */
/* eslint global-require: "off" */
// import 'css-paint-polyfill';
import 'focus-visible';
import 'intersection-observer';
import 'resize-observer-polyfill';

if (BUILD_TYPE === 'legacy') {
    require('core-js/es/symbol');
    require('core-js/es/promise/finally');
    require('document-register-element/build/document-register-element');
    require('whatwg-fetch');
}
